import styled from 'styled-components';

import zIndex from 'consts/zIndex';

const loaderContainerStyles = props => `
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: ${props.theme.colors.white};
  overflow: hidden;
  z-index: ${zIndex.loadingScreen};
`;

export const LoaderContainer = styled.div`
  ${props => loaderContainerStyles(props)}
`;

export const LoaderContainerFallback = styled.div`
  ${props => loaderContainerStyles(props)}
  /** "position: fixed" doesn't work during webview redirect */
  position: absolute;
`;

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LoaderGif = styled.img`
  width: 225px;
`;

export const LoaderText = styled.p`
  width: 275px;
  font-family: ${props => props.theme.fonts.primaryFont};
  font-size: 18px;
  text-align: center;
`;
